import { render, staticRenderFns } from "./CourierVehicles.vue?vue&type=template&id=138cb046"
import script from "./CourierVehicles.vue?vue&type=script&lang=js"
export * from "./CourierVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports